const icon = state => state.icon;
const contractors = state => state.contractors;
const contractor = state => state.contractor;
const regions = state => state.regions;
const region = state => state.region;
const contacts = state => state.contacts;
const contact = state => state.contact;
const contractorRegionDropdownOptions = state =>
  state.contractorRegionDropdownOptions;

export default {
  icon,
  contractors,
  contractor,
  regions,
  region,
  contacts,
  contact,
  contractorRegionDropdownOptions
};
